(() => {
  const story = document.querySelector('#sequence-story');
  const host = story?.querySelector('.portrait-screen');
  if (!host) return;
  const frame = host.querySelector('.approved-practice-frame');
  frame.title = 'Create a practice';
  frame.className = 'approved-practice-frame';
  frame.setAttribute('scrolling', 'no');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let ready = false, queued = false, lastProgress = '';
  function fitSequenceTitles() {
    story.querySelectorAll('.sequence-name').forEach(title => {
      title.style.removeProperty('font-size');
      const available = title.clientWidth;
      if (!available || title.scrollWidth <= available) return;
      const size = parseFloat(getComputedStyle(title).fontSize);
      title.style.fontSize = `${size * available / title.scrollWidth * .98}px`;
    });
  }
  const fit = () => {
    frame.style.transform = `scale(${host.clientWidth / 375},${host.clientHeight / 812})`;
    fitSequenceTitles();
  };
  function scrub() {
    queued = false;
    if (!ready || !frame.contentWindow) return;
    // Use the original story's coordinate: setup precedes its .23 rotation start.
    const rect = story.getBoundingClientRect();
    const progress = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height - innerHeight)));
    // Animate length during entry; the existing option/Start timeline is unchanged.
    const durationControl = frame.contentDocument?.querySelector('.duration-ruler');
    const frameRect = frame.getBoundingClientRect();
    const controlRect = durationControl?.getBoundingClientRect();
    const durationTop = frameRect.top + (controlRect?.top ?? 165) * frameRect.height / Math.max(1, frame.clientHeight);
    const durationProgress = progress > 0 ? 1 : Math.max(0, Math.min(1, (innerHeight * .88 - durationTop) / (innerHeight * .35)));
    const key = `${progress.toFixed(4)}:${durationProgress.toFixed(4)}:${reduced.matches}`;
    if (key === lastProgress) return;
    lastProgress = key;
    story.dataset.practiceDemoProgress = progress.toFixed(4);
    if (progress < .17) delete story.dataset.practiceDemo;
    frame.contentWindow.postMessage({type:'yoga-create-practice-progress', progress, durationProgress, reducedMotion:reduced.matches}, location.origin);
  }
  function requestScrub() {
    if (!queued) { queued = true; requestAnimationFrame(scrub); }
  }
  const onReady = () => {
    if (!frame.contentDocument?.querySelector('.start') || ready) return;
    ready = true;
    host.classList.add('has-approved-practice');
    fit();
    requestScrub();
  };
  new ResizeObserver(fitSequenceTitles).observe(story.querySelector('.landscape-screen'));
  const reducedPlayer = story.querySelector('.reduced-player-screen');
  if (reducedPlayer) new ResizeObserver(fitSequenceTitles).observe(reducedPlayer);
  frame.addEventListener('load', onReady);
  if (frame.contentDocument?.readyState === 'complete') onReady();
  new ResizeObserver(() => { fit(); requestScrub(); }).observe(host);
  function applySettings(settings) {
    if (typeof settings.style === 'string' && typeof settings.focus === 'string') {
      story.querySelectorAll('.sequence-name').forEach(title => { title.textContent = `${settings.style} ${settings.focus}`; });
      fitSequenceTitles();
    }
    const duration = story.querySelector('#duration-slider');
    const minutes = Number(settings.duration);
    if (Number.isFinite(minutes) && duration) {
      duration.max = '90';
      duration.value = String(Math.max(5, Math.min(90, minutes)));
      duration.dispatchEvent(new Event('input', {bubbles:true}));
    }
    for (const [id, value] of [['practice-select',settings.style],['focus-select',settings.focus]]) {
      const select = story.querySelector(`#${id}`);
      if (!select || ![...select.options].some(option => option.value === value)) continue;
      select.value = value;
      select.dispatchEvent(new Event('change', {bubbles:true}));
    }
    if (['Gentle','Steady','Strong'].includes(settings.intensity)) {
      story.querySelector(`[data-intensity="${settings.intensity}"]`)?.click();
    }
  }
  window.addEventListener('message', event => {
    if (event.origin !== location.origin || event.source !== frame.contentWindow) return;
    if (event.data?.type === 'yoga-create-practice-back') {
      document.querySelector('#build-title')?.scrollIntoView({behavior:reduced.matches ? 'instant' : 'smooth',block:'center'});
      return;
    }
    if (event.data?.type === 'yoga-create-practice-demo-settings') {
      applySettings(event.data);
      return;
    }
    if (event.data?.type !== 'yoga-create-practice-start') return;
    applySettings(event.data);
    if (event.data.demo === true) {
      // The scroll-driven press activates setup without a timed scroll tour.
      // The original morph engine continues the user's scroll into the player.
      story.dataset.practiceDemo = 'started';
      return;
    }
    story.querySelector('#practice-button')?.click();
  });
  addEventListener('scroll', requestScrub, {passive:true});
  addEventListener('resize', requestScrub);
  reduced.addEventListener('change', () => { lastProgress = ''; requestScrub(); });
})();
